<!-- 政务通用农机鉴定、购置补贴、农机监管、报废补贴页面切换组件 -->
<template>
  <div class="chose-page-box" :style="flexDirection" id="chosePageBox">
    <div v-for="item in allowBtn" @click="choseItem(item)">
      <img :src="require(`@/assets/images/governmentAffairs/common/${item.imgName}${item.chosed == true ? '_c' : ''}.png`)"></img>
    </div>
  </div>
</template>
<script>
export default {
  inject: ["reload"],
  name: 'ChosePage',
  props: {
    flexDirection: {
      type: String,
      default: 'flex-direction: row;'
    },
  },
  watch: {
    '$route': {
      deep: true,
      immediate: true,
      handler(newVal, oldVal) {
        for(let i = 0;i< this.pageList.length;i++) {
          if(this.pageList[i].routeName == newVal.name) {
            this.choseItem(this.pageList[i]);
            break;
          }
        }
      },
    },
  },
  computed: {
    allowBtn() {
      let self = this;
      const permissions = self.$store.getters.permissions || [];
      const managerEnabled = true;
      let list = permissions.includes('*:*:*') && managerEnabled ? self.pageList : self.pageList.filter(btn => permissions.includes(btn.permissionName));
      return list;
    }
  },
  data() {
    return {
      pageList:[
        {
          name: '购置补贴',
          routeName: 'PurchaseAllowance',
          clickId: '1',
          chosed: false,
          imgName: 'menu_gzbt',
          path: '/governmentAffairs/purchaseAllowance',
          permissionName: 'screen:gov:purchaseAllowance'
        },
        {
          name: '农机监理',
          routeName: 'Vehiclesupervisor',
          clickId: '2',
          chosed: false,
          imgName: 'menu_njjl',
          path: '/governmentAffairs/vehiclesupervisor',
          permissionName: 'screen:gov:vehiclesupervisor'
        },
        {
          name: '报废补贴',
          routeName: 'ScrapSubsidy',
          clickId: '3',
          chosed: false,
          imgName: 'menu_bfbt',
          path: '/governmentAffairs/scrapSubsidy',
          permissionName: 'screen:gov:ScrapSubsidy'
        },
      ],
      selectedItem: null,
    }
  },
  methods: {
    choseItem(obj) {
      this.pageList.forEach(item => {
        if(obj.clickId == item.clickId) {
          item.chosed = true;
          this.selectedItem = item;
        }else {
          item.chosed = false;
        }
      })
      if(this.selectedItem) {
        if (this.$route.name == obj.routeName) {
          this.reload();
        } else {
          this.$router.push({
            path: this.selectedItem.path,
          });
        }
      }
    },
  }
}
</script>
<style scoped lang="scss">
@function vw($px) {
  @return ($px / 1920) * 100vw;
}

@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.chose-page-box {
  display: flex;
  cursor: pointer;
  img {
    width: vw(107);
    height: vh(112);
    margin-right: vw(31);
  }
}
</style>
